/* eslint-disable @typescript-eslint/naming-convention */
import { useState } from 'react'
import { Search2Icon } from '@chakra-ui/icons'
import { Box, Input, InputGroup, InputLeftElement } from '@chakra-ui/react'

import { PlayerResultList } from '@components/LineupAndSubsPreview/LineupEditModal/PlayerResultList'

import { usePlayerSearch } from '@hooks/usePlayerSearch'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

export function AllPlayersSearchField() {
    const [search, setSearch] = useState('')
    const { players, isLoading, isError } = usePlayerSearch(search)

    const { setNewPlayer } = useAddPlayerContext()

    const handlePlayerSelect = player => {
        setNewPlayer({
            id: player.id,
            name: player.name,
            surname: player.surname,
            shirt_number: player.shirtNumber,
            captain: player.captain ?? false,
            playerDetailUrl: player.playerDetailUrl,
        })

        setSearch('')
    }

    return (
        <Box w="full">
            <InputGroup>
                <InputLeftElement pointerEvents="none">
                    <Search2Icon color="gray.300" />
                </InputLeftElement>
                <Input
                    className="search-value-input"
                    placeholder="Search player"
                    background="white"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    type="search"
                />
            </InputGroup>
            {players && (
                <Box
                    padding={2}
                    position="absolute"
                    zIndex={10}
                    maxH="300px"
                    overflowY="scroll"
                    w="full"
                    maxW="360px"
                    bg="white"
                    borderRadius="16"
                    borderWidth="1px"
                    mt={2}>
                    <PlayerResultList
                        isPlayerListLoading={isLoading}
                        freePlayers={players}
                        isErrorFetchingSquad={isError}
                        handleFreePlayerSelect={handlePlayerSelect}
                    />
                </Box>
            )}
        </Box>
    )
}
